"use client";
import Link from "next/link";
import { X } from "lucide-react";
import { Button } from "./ui/button";
import { Logo } from "@/assets/icons";

interface MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
  handleNavClick: (id: string, e: React.MouseEvent) => void;
}

const MobileMenu = ({ isOpen, onClose, handleNavClick }: MobileMenuProps) => {
  const NAV_ITEMS = [
    { id: "home", label: "Home", link: "/" },
    { id: "design-workk", label: "Design Work" },
    { id: "what-we-do", label: "What We Do" },
    { id: "about", label: "About" },
    {
      id: "cost-calculator",
      label: "Cost Calculator",
      link: "/cost-calculator",
    },
  ];
  return (
    <div
      className={`fixed inset-0 bg-white z-[999999] transition-transform duration-500 ease-in-out ${
        isOpen ? "translate-x-0" : "translate-x-full"
      }`}
    >
      <div className="flex flex-col bg-white p-6">
        <div className="flex items-center justify-between mb-8">
          <div>
            <Link
              href="/"
              className="text-2xl flex gap-2 font-bold text-primary"
            >
              <Logo className="w-9 h-9" />
              <span>Digital Thrive</span>
            </Link>
          </div>
          <button
            onClick={onClose}
            className="p-2 rounded-full hover:bg-muted transition-colors"
            aria-label="Close menu"
          >
            <X className="w-6 h-6" />
          </button>
        </div>

        <div className="flex flex-col space-y-4 mt-4">
          {NAV_ITEMS.map((item) =>
            item.link ? (
              <Link
                key={item.label}
                href={item.link}
                onClick={onClose}
                className="text-primary"
              >
                {item.label}
              </Link>
            ) : (
              <Link
                key={item.label}
                href={`#${item.id}`}
                onClick={(e) => {
                  handleNavClick(item.id, e);
                  onClose();
                }}
                className="text-primary"
              >
                {item.label}
              </Link>
            )
          )}

          <div className="mt-5">
            <Button
              onClick={(e) => {
                onClose();
                handleNavClick("contact-us", e);
              }}
            >
              Start a project
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;
